import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function useShiftStatus () {
  const isMine = useValue('is_mine')
  const isOnSale = useValue('is_on_sale')
  const hasExchangesToBeApproved = useValue('has_exchanges_to_be_approved')
  const iCreatedSomeRequests = useValue('i_created_some_requests')

  let color = isMine ? 'green' : 'bg-white'

  color = (!isMine && isOnSale) ? 'orange' : color

  let shiftState = 'default'

  if (hasExchangesToBeApproved) {
    shiftState = 'awaiting_approval'
  } else {
    if (isOnSale || iCreatedSomeRequests) {
      if (isMine) {
        shiftState = 'mine-pending'
      } else if (iCreatedSomeRequests) {
        shiftState = 'pending'
      }
    }
  }

  return { color, status: shiftState }
}
